"use strict";
var _AjvFactory_instance;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AjvFactory = void 0;
const tslib_1 = require("tslib");
const ajv_1 = tslib_1.__importDefault(require("ajv"));
const ajv_formats_1 = tslib_1.__importDefault(require("ajv-formats"));
const pluralize_1 = require("pluralize");
class AjvFactory {
    constructor(schemaService) {
        this.schemaService = schemaService;
        _AjvFactory_instance.set(this, void 0);
    }
    getInstance() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!tslib_1.__classPrivateFieldGet(this, _AjvFactory_instance, "f")) {
                if (!this.schemaService)
                    throw new Error("no schemaService defined");
                tslib_1.__classPrivateFieldSet(this, _AjvFactory_instance, new ajv_1.default({
                    strict: false,
                    strictSchema: false,
                    removeAdditional: "all",
                    strictNumbers: false,
                    allErrors: true,
                    loadSchema: (uri) => {
                        const refName = uri.substring(uri.lastIndexOf("/") + 1);
                        return this.schemaService.getSchemaByName(refName);
                    }
                }), "f");
                (0, ajv_formats_1.default)(tslib_1.__classPrivateFieldGet(this, _AjvFactory_instance, "f"));
                // Workaround for loadSchema not working
                const allSchemas = yield this.schemaService.getAllSchemas();
                for (const key in allSchemas)
                    tslib_1.__classPrivateFieldGet(this, _AjvFactory_instance, "f").addSchema(allSchemas[key], "#/components/schemas/" + (0, pluralize_1.singular)(key));
            }
            return tslib_1.__classPrivateFieldGet(this, _AjvFactory_instance, "f");
        });
    }
}
exports.AjvFactory = AjvFactory;
_AjvFactory_instance = new WeakMap();
